import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { useTheme } from 'styled-components';

import { Container } from './styles';
import { ConfigApi } from '../../../../config/Constantes';
import { capitalizeStr } from '../../../../util/functions';
import { corTextoSobre, mix, tonsCategoria } from '../../../../util/coresTema';

// grade de categorias usada no template 1 do cardápio
function CategoriasGrade(props) {
  CategoriasGrade.propTypes = {
    numeroContrato: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    grupos: PropTypes.arrayOf(PropTypes.object),
    onSelecionaGrupo: PropTypes.func,
  };

  CategoriasGrade.defaultProps = {
    numeroContrato: '',
    grupos: [],
  };

  const theme = useTheme();
  const tons = useMemo(() => tonsCategoria(theme.colors.primary), [theme.colors.primary]);

  // grupos cuja imagem falhou ao carregar passam a exibir a inicial
  const [imagensComErro, setImagensComErro] = useState([]);

  const { grupos, numeroContrato, onSelecionaGrupo } = props;

  // render principal
  return (
    <Container>
      <h1>Categorias</h1>
      <div className="container-grade">{renderCategorias()}</div>
    </Container>
  );

  function renderCategorias() {
    return grupos.map((gp, idx) => {
      const nomeCategoria = capitalizeStr(gp.nomeCompleto || gp.nome);
      const fundo = tons[idx % tons.length];
      const corTexto = corTextoSobre(fundo);

      return (
        <button
          type="button"
          key={`gp_grade_id_${gp.id}`}
          className="container-item"
          style={{ backgroundColor: fundo }}
          onClick={() => {
            if (onSelecionaGrupo) {
              onSelecionaGrupo(gp.id);
            }
          }}
          title={nomeCategoria}
        >
          <span className="nome-categoria" style={{ color: corTexto }}>
            {nomeCategoria}
          </span>
          {renderImagem(gp, fundo)}
        </button>
      );
    });
  }

  function renderImagem(gp, fundo) {
    if (gp.exibirImagem && !imagensComErro.includes(gp.id)) {
      return (
        <span className="foto-categoria">
          <img
            src={`${ConfigApi.baseURL}/files/${numeroContrato}/g${gp.id}.jpg`}
            onError={() => setImagensComErro([...imagensComErro, gp.id])}
            alt="categoria"
          />
        </span>
      );
    }

    // sem imagem: ícone de imagem no círculo, em tom claro do próprio card
    return (
      <span className="foto-categoria" style={{ backgroundColor: mix(fundo, '#ffffff', 0.6) }}>
        <svg
          aria-hidden="true"
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          stroke={fundo}
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="4" width="18" height="16" rx="3" />
          <circle cx="9" cy="10" r="2" />
          <path d="m21 16-5-5-9 9" />
        </svg>
      </span>
    );
  }
}

export { BarraVoltar } from './styles';

export default CategoriasGrade;
